module.exports = __webpack_public_path__ + "media/svg/lock-5cde853f.svg";